import {Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {Body} from '../../../components/Body/Body'
import {tagToUrl} from '../../../lib/tagToUrl'
import {BusinessToggle} from '../../BusinessToggle/BusinessToggle@desktop'
import {RequirementsBlock} from '../../RequirementsBlock/index@desktop'
import {SegmentWidget} from '../../Segment/index@desktop'
import type {SectionProps as Props, SegmentWidgetConfig, VerticalsWidgetConfig} from '../../types'
import {VerticalsWidget} from '../../Verticals/index@desktop'
import * as classes from './VerticalsSection@desktop.classes'

export function VerticalsSection(props: Props): ReactElement {
  const {widgets} = props.section
  const businessWidget = widgets.find(widget => widget.widget_id === 'cargo_c2c_order_forms_b2b_lk_verticals_widget')
  const i18n = useI18n()
  const verticalsWidget = widgets.find(widget => widget.type === 'verticals') as VerticalsWidgetConfig
  const directionsWidget = widgets.find(
    widget => widget.widget_id === 'vertical_group_id_wide_segment_widget',
  ) as SegmentWidgetConfig

  return (
    <Grid xs={12} item>
      <Paper className={classes.paper} radius="L">
        <Grid alignItems="center" className={classes.root} wrap="nowrap" container>
          <Grid className={classes.lead} item>
            <img
              alt=""
              height={spacing(4.5)}
              loading="lazy"
              src={tagToUrl('delivery_header_package_icon')}
              width={spacing(4.25)}
            />
          </Grid>
          <Typography Component={Grid} group="tight" thickness="medium" variant="title4" item>
            <Typography group="tight" thickness="medium" variant="title4">
              {i18n('cargo.create.form.order', 'Заказать')}
            </Typography>
          </Typography>
          {!!businessWidget && (
            <Grid className={classes.tail} item>
              <BusinessToggle />
            </Grid>
          )}
        </Grid>
        {directionsWidget && <Body tail={<SegmentWidget config={directionsWidget} />} />}
        {verticalsWidget && <VerticalsWidget config={verticalsWidget} />}
        <RequirementsBlock {...props} />
      </Paper>
    </Grid>
  )
}
